import React, { useState } from 'react';
import { ChevronDownIcon, Menu, Pressable } from 'native-base';
import { GiftCard, useI18n, useSpringBigStore, useTheme } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import OurPressable from '~/shared/Pressable';
import { Input } from '~/shared/Theme';

const SelectLoyalty = ({
    loyaltyCard,
    setLoyaltyCard
}: {
    loyaltyCard: GiftCard | null,
    setLoyaltyCard: React.Dispatch<React.SetStateAction<GiftCard | null>>
}) => {

    const { giftCards } = useSpringBigStore();
    const [isOpen, setMenuOpen] = useState(false);
    const { t } = useI18n();

    const {
        primary,
        radius_md,
        modal,
        modal_text,
        button_primary,
        button_text,
    } = useTheme();

    const handlePress = () => {

        setMenuOpen(!isOpen);
    };

    return (
        <Input
            keyboardType={'numeric'}
            placeholder={t('giftCard.field.method')}
            value={loyaltyCard?.card_number.slice(-5) || t('giftCard.field.loyalty')}
            isDisabled
            InputRightElement={
                giftCards && giftCards.length > 0 ?
                    <Menu
                        placement={'bottom'}
                        defaultIsOpen={false}
                        isOpen={isOpen}
                        background={modal}
                        color={modal_text}
                        rounded={radius_md}
                        p={0}
                        onOpen={() => handlePress()}
                        onClose={() => handlePress()}
                        trigger={triggerProps => {

                            return <Pressable accessibilityLabel={'More options menu'} {...triggerProps}>
                                <ChevronDownIcon color={primary} size={'lg'} px={2} />
                            </Pressable>;
                        }}>

                        {
                            giftCards
                                .filter((item) => !item.is_closed_loop)
                                .map((item) => {

                                    return (
                                        <Menu.Item
                                            key={item.card_number}
                                            backgroundColor={'transparent'}
                                            borderRadius={radius_md}
                                            padding={0}
                                        >
                                            <OurPressable
                                                py={2}
                                                px={4}
                                                w={'full'}
                                                onPress={() => setLoyaltyCard(item)}
                                            >
                                                <Caption
                                                    w={'full'}
                                                    fontSize={22}
                                                    fontWeight={'200'}
                                                >
                                                    { item.card_number.slice(-5) }
                                                </Caption>
                                            </OurPressable>
                                        </Menu.Item>
                                    );
                                })
                        }
                    </Menu>
                    :
                    <></>
            }
        />
    );
};

export default SelectLoyalty;
